module.exports = __webpack_public_path__ + "static/bgIsoTipo-c465043f7664430a2056570bb18f0b29.svg";